import { Form, Input } from 'antd';
import React from 'react';

import { ItemTaskType } from '../../types';

const FieldNumber = () => {
    return (
        <Form.Item<ItemTaskType> label="Number" name="number">
            <Input disabled={true} />
        </Form.Item>
    );
};

export default React.memo(FieldNumber);
